$(document).ready(function () {
  Begin(true);

  setScrollOpacityEvents();

  //keep unit buttons in sync with the buttons that intiaro disables
  const syncButtonStatesObserver = new MutationObserver(syncButtonStates);
  syncButtonStatesObserver.observe(document.body, { childList: true, subtree: true });
});

//------------------------------------------------------------------

async function addModularToCart() {
  let modularSkus = window.skuString;
  if (!modularSkus) return;

  const lines = modularSkus.split('\n').filter(Boolean);

  const positionsAndSkus = lines.map(line => {
    const [position, sku] = line.split(':').map(part => part.trim());
    return { position, sku };
  });

  const shortSkus = positionsAndSkus.map(obj => obj.sku.split('-')[0]);
  const fullSkus = positionsAndSkus.map(obj => obj.sku);
  const positions = positionsAndSkus.map(obj => obj.position);

  console.log(`short: ${shortSkus} -- full ${fullSkus}  --  pos ${positions}`);

  const items = getModularItemsFromSelections();

  (async () => {
    const total = (await Promise.all(items.map(i =>
      fetch(`/variants/${i.id}.json`)
        .then(r => r.json())
        .then(d => (+(d.product_variant?.price ?? d.variant?.price ?? 0)) * (i.quantity || 1))
    ))).reduce((a, b) => a + b, 0);
    console.log("total", formatCurrency(total));
  })();

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify({ items }),
    success: function () {
      fetch(`/?section_id=sections--18213389434924__header_section`)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, "text/html");
          const newCartSection = doc.querySelector("cart-items-component");
          const existingCartSection = document.querySelector("cart-items-component");
          if (newCartSection && existingCartSection) {
            existingCartSection.innerHTML = newCartSection.innerHTML;
          }

          const drawer = document.querySelector("cart-drawer-component");
          if (drawer && typeof drawer.open === "function") {
            drawer.open();
          }
        });
    },
    error: function (error) {
      //console.error("Error:", error);
      console.error("Error adding to cart:", error.responseText);
    },
  });
}

function getModularItemsFromSelections() {
  let modularSkus = window.skuString;
  if (!modularSkus) return [];

  const lines = modularSkus.split('\n').filter(Boolean);

  const positionsAndSkus = lines.map(line => {
    const [position, sku] = line.split(':').map(part => part.trim());
    return { position, sku };
  });

  const shortSkus = positionsAndSkus.map(obj => obj.sku.split('-')[0]);
  const fullSkus = positionsAndSkus.map(obj => obj.sku);
  const positions = positionsAndSkus.map(obj => obj.position);

  const items = shortSkus.map((shortSku, i) => ({
    id: getVariantIdByUnit(shortSku),
    quantity: 1,
    properties: {
      custom_sku: fullSkus[i],
      position: positions[i],
    }
  }));

  return items;
}



async function Begin(firstTime) {
  const checkInterval = setInterval(async () => {
    //setup an interval check to wait for intiaro to load
    if ($("#hmc360-viewer").text().trim() == "Loading...") return; //keep waiting until intiaro is done loading
    clearInterval(checkInterval); //stop checking if intiaro is done loading

    const unitChoicesData = await getIntiaroModularUnitsData();
    createUnitOptionsSection(unitChoicesData);

    setupDragging();

    getIntiaroPlayer("hmc360-viewer").registerListener("isSectionalBuilderOpen", async callBack => {
      if (callBack.isSectionalBuilderOpen == false && firstTime) {
        $("#hmc360-modular-customizer-container").hide();
        $(".hmc360-modular-section").remove();
        $("#hmc360-finish-building-button").remove();
        $("#hmc360-modular-customizer-container").show();
        $("#hmc360-console-customizer-container").show();
        $("#hmc360-back-to-ouliner-button").show();
        $("#hmc360-modular-tabs-container").css("display", "flex");
        $("#hmc360-options-container").css("display", "flex");
        $("#hmc360-special-buttons-container").css("display", "flex");

        await loadCustomizationOptions();
      }

      if (callBack.isSectionalBuilderOpen == false) {
        generateDetails();
      } else {
        $('#fixed-modular-footer-atc').css("display", "none");
      }
    });

    getIntiaroPlayer("hmc360-viewer").registerListener("configurationChanged", () => {
      generateDetails();
    });
  }, 100);
}

async function getIntiaroModularUnitsData() {
  const allChoicesData = new Map();

  //find the group-name "Sections" and its parent .controllerWrapper
  const $sectionsGroupName = $(".controllerWrapper .group-name")
    .filter(function () {
      return $(this).text().trim() === "Sections";
    })
    .first();

  if ($sectionsGroupName.length === 0) {
    return [];
  }

  //find all .choiceIconContainer descendants within this group
  const $controllerWrapper = $sectionsGroupName.closest(".controllerWrapper");
  const $choices = $controllerWrapper.find(".choiceIconContainer");

  $choices.each(function () {
    const $choice = $(this);
    const id = $choice.attr("id");
    if (!id || allChoicesData.has(id)) return;

    const label = $choice.attr("aria-label");
    const img = $choice.find("img.choiceIcon")[0];
    let src = typeof getThumbnail === "function" ? getThumbnail(label) : null;
    if (!src && img) src = $(img).attr("data-src") || $(img).attr("src") || "";

    //find section title for this choice
    const section = $choice.closest(".section").find(".sectionTitle").text().trim();

    //find slugKey (from sectionContainer[attribute]), slugValue (the id)
    const sectionContainerAncestor = $choice.closest(".sectionContainer")[0];
    const slugKey = sectionContainerAncestor ? $(sectionContainerAncestor).attr("attribute") : "";
    const slugValue = id;

    allChoicesData.set(id, { slugKey, slugValue, label, src, section });
  });

  return allChoicesData;
}

async function createUnitOptionsSection(unitChoicesData) {
  const player = getIntiaroPlayer("hmc360-viewer");
  const optionsContainer = $("#hmc360-modular-customizer-container");

  //remove all options from container
  optionsContainer.find(".hmc360-section").remove();

  //group choices by section
  const sectionsMap = new Map();
  for (const choice of unitChoicesData.values()) {
    if (!sectionsMap.has(choice.section)) {
      sectionsMap.set(choice.section, []);
    }
    sectionsMap.get(choice.section).push(choice);
  }

  //render each section
  sectionsMap.forEach(choices => {
    const sectionDiv = $("<div></div>").addClass("hmc360-modular-section");

    //section title
    const sectionTitle = $("<h4></h4>").text("Let's start by outlining the layout");
    sectionDiv.append(sectionTitle);

    //choices container
    const choiceButtonsContainer = $("<div></div>").addClass("hmc360-choice-buttons-container");
    for (const choice of choices) {
      //button element
      const button = $("<button></button>")
        .attr("title", choice.label || choice.slugValue)
        .attr("slug-value", choice.slugValue)
        .addClass("hmc360-choice-button")
        .addClass("hmc360-unit-button")
        .addClass("draggable")
        .attr("draggable", true);

      //image element
      const image = $("<img />").attr("src", choice.src).attr("alt", choice.label);
      button.append(image);

      //label element
      const label = $("<div></div>").text(choice.label);
      button.append(label);

      button.on("click", async () => {
        $(".choiceIconContainer#" + choice.slugValue).trigger("click");
        syncButtonStates();
      });

      choiceButtonsContainer.append(button);
    }
    sectionDiv.append(choiceButtonsContainer);
    optionsContainer.append(sectionDiv);

    const finishButton = $("<button>Finish Building</button>").attr("id", "hmc360-finish-building-button");
    finishButton.on("click", () => {
      $("#finishButton").trigger("click");
      $("#hmc360-modular-customizer-container").css("transform", "translateY(40%)");
    });
    setupFinishBuildingButtonObserver();
    optionsContainer.append(finishButton);
  });
}

async function loadCustomizationOptions() {
  const choicesData = await getAllChoicesData();
  console.log("choices data", choicesData);
  let orderedTabsData = await getOrderedElementsWIthChoicesData(choicesData);
  buildUnitTabs(orderedTabsData);
  setupSelectAllButton(orderedTabsData);

  $(".hmc360-tab").first().trigger("click");

  if (isSelectAllChecked()) {
    $("#hmc360-select-all").trigger("click");
  }
}

async function getAllChoicesData() {
  const allChoicesData = [];
  const tabs = $(".variable-group-tab:not(#variable-group_sections)");
  console.log(tabs);

  for (let i = 0; i < tabs.length; i++) {
    const tab = tabs[i];
    tab.click();
    await new Promise(resolve => setTimeout(resolve, 300));

    const controllerWrapper = $(".overflowWrapper .controllerWrapper")[0];

    if (controllerWrapper) {
      const sections = $(controllerWrapper).find(".section");
      sections.each(function () {
        $(this).removeClass("disabledSection");
      });

      // Expand all closed sections
      for (let j = 0; j < sections.length; j++) {
        const section = sections.eq(j);
        const sectionContainer = section.find(".sectionContainer")[0];
        const sectionTitle = section.find(".sectionTitle")[0];

        if (sectionTitle) {
          console.log(sectionTitle.text);
          sectionTitle.click();
          await new Promise(resolve => setTimeout(resolve, 200));
        }
      }

      // Process each choice group within sections
      const choiceGroups = $(controllerWrapper).find(".choiceGroupItem");
      for (let k = 0; k < choiceGroups.length; k++) {
        const group = choiceGroups.eq(k);

        //extract unit's id
        const unit_id = group.find("intiaro-two-states-button").attr("id");

        //extract group label
        const groupLabel = group.find(".two-states-button span").text().trim();

        //extract choices within this group
        const choices = group.find(".choiceIconContainer");
        for (let l = 0; l < choices.length; l++) {
          const choice = choices.eq(l);
          const id = choice.attr("id");
          const label = choice.attr("aria-label");
          const img = choice.find("img.choiceIcon")[0];
          const src = $(img).attr("data-src");

          const section = choice.closest(".section").find(".sectionTitle").text().trim();
          const sectionContainerAncestor = choice.closest(".sectionContainer")[0];
          const slugKey = sectionContainerAncestor ? $(sectionContainerAncestor).attr("attribute") : "";

          allChoicesData.push({
            slugKey,
            slugValue: id,
            label,
            src,
            section,
            unit: groupLabel,
            unit_id,
          });
        }
      }
    }
  }

  console.log(allChoicesData);

  return allChoicesData;
}

async function getOrderedElementsWIthChoicesData(choicesData) {
  let result = {};

  await getIntiaroPlayer("hmc360-viewer").getModularConfiguration(false, selections => {
    console.log("selections", selections);
    let rawOrderedElements = getOrderedElements(selections);

    let orderedELementsWithLabels = setElementCabinetLabels(rawOrderedElements);

    let orderedElementsWithChoices = attachChoicesToOrderedElements(orderedELementsWithLabels, choicesData);

    result = orderedElementsWithChoices;
  });

  return result;
}

async function createChoicesSections(choicesData, orderedTabsData) {
  const player = getIntiaroPlayer("hmc360-viewer");
  const optionsContainer = $("#hmc360-options-container");

  //remove all options from container
  optionsContainer.find(".hmc360-section").each(function () {
    $(this).remove();
  });

  //group choices by section
  const sectionGroups = {};
  choicesData.forEach(choice => {
    const section = choice.section || "default";
    if (!sectionGroups[section]) {
      sectionGroups[section] = [];
    }
    sectionGroups[section].push(choice);
  });

  const sectionOrder = ["Finish", "Door Style", "Door Hardware", "Drawer Style", "Drawer Hardware", "Premium Surface Top", "FIREPLACE"];

  if (sectionGroups["FIREPLACE"]) {
    const fireplaceChoices = sectionGroups["FIREPLACE"];
    const controller = getIntiaroController("hmc360-configurator");
    const elements = controller.modelInstance.productConfiguration.elements;

    for (const choice of fireplaceChoices) {
      try {
        elements.get(choice.unit_id)?.changeAttributeCommand?.handle({
          attribute: "hm_0423_fireplace",
          value: "hm_0423_fireplace_crystal"
        });
      } catch (err) {
        console.warn(`FIREPLACE attribute change failed for ${choice.unit_id}`, err);
      }
    }

    //remove FIREPLACE from the sectionGroups so it's not rendered
    delete sectionGroups["FIREPLACE"];
  }

  //this will iterate through each section and create the html
  Object.entries(sectionGroups)
    .sort(([a], [b]) => {
      //first it sorts
      const indexA = sectionOrder.indexOf(a);
      const indexB = sectionOrder.indexOf(b);
      if (indexA === -1 && indexB === -1) return 0;
      if (indexA === -1) return 1;
      if (indexB === -1) return -1;
      return indexA - indexB;
    })
    .forEach(([section, choices]) => {
      //don't give users ability to customize fireplace
      if (section === "FIREPLACE"){
        return;
      }  

      //create a new section
      const sectionDiv = $("<div></div>").addClass("hmc360-section").attr("id", section).attr("data-section", choices[0].slugKey);

      //create the section title
      const sectionTitle = $("<h4></h4>");
      sectionTitle.text(section);
      sectionDiv.append(sectionTitle);

      //create the button container and add the buttons to it
      const choiceButtonsContainer = $("<div></div>").addClass("hmc360-choice-buttons-container");

      for (let choice of choices) {
        //create button element
        const button = $("<button></button>")
          .attr("title", choice.label || choice.slugValue)
          .addClass("hmc360-choice-button")
          .attr("draggable", true)
          .addClass("draggable");

        //create image element
        let src = getChoiceThumbnail(choice.label);
        if (src == null) {
          src = choice.src;
        }
        const image = $("<img />").attr("src", src).attr("alt", choice.label);
        button.append(image);

        //create label element
        const label = $("<div></div>").text(choice.label);
        button.append(label);

        //add click event for button
        button.on("click", async () => {
          const attributes = { attribute: choice.slugKey, value: choice.slugValue };

          const controller = getIntiaroController("hmc360-configurator");
          const elements = controller.modelInstance.productConfiguration.elements;
          console.log("elements", elements);

          if (isSelectAllChecked()) {
            $(".hmc360-tab").each(function () {
              const elementId = $(this).attr("id");
              if (elementId) {
                const variables = elements.get(elementId)?._attributes;
                if (variables && variables.has(attributes.attribute)) {
                  try {
                    elements.get(elementId)?.changeAttributeCommand?.handle(attributes);
                  } catch (err) {
                    console.warn(`Attribute change failed for element ${elementId}`, err);
                  }
                }
              }
            });
          } else {
            try {
              elements.get(choice.unit_id)?.changeAttributeCommand?.handle(attributes);
            } catch (err) {
              console.warn(`Attribute change failed for element ${choice.unit_id}`, err);
            }
          }

          try {
            controller.modelInstance.refreshView();
          } catch (err) {
            console.warn("View refresh failed", err);
          }

          if (isAutoScroll()) scrollToSection(true);
        });

        //add the button to the button container
        choiceButtonsContainer.append(button);
      }

      //add the button container to the section
      sectionDiv.append(choiceButtonsContainer);
      optionsContainer.append(sectionDiv);
    });

  //moved this out of the if condition to see if it will work in all conditions
  optionsContainer.append(getEndOfChoicesDiv(choicesData, orderedTabsData));
}

function getElementVariables(elementId) {
  console.log(elements.get(elementId)?._attributes);
  return elements.get(elementId)?._attributes;
}

async function getAttributesToChange(choice) {
  //returns an array of attributes that intiaro will accept

  let attributes = {};
  attributes[choice.slugKey] = choice.slugValue;
  return attributes;
}

function buildUnitTabs(orderedTabsData) {
  console.log(orderedTabsData);
  const tabsContainer = $("#hmc360-modular-tabs-container");

  const bottomTabsDiv = $("<div></div>").addClass("hmc360-tabs");

  const topTabsDiv = $("<div></div>").addClass("hmc360-tabs");

  for (const bottomTab of orderedTabsData.orderedBottomElements) {
    const bottomTabDiv = $("<div></div>").addClass("hmc360-tab").addClass(getTabSizeClass(bottomTab.choices[0].unit)).attr("id", bottomTab.elementKey);

    const bottomLabel = $(`<div>${bottomTab.cabinetLabel}</div>`);
    //bottomTabDiv.append(bottomLabel);

    const bottomImg = $(`<img src="${getUnitThumbnail(bottomTab.choices[0].unit)}"/>`);
    bottomTabDiv.append(bottomImg);

    bottomTabDiv.on("click", function () {
      $(".hmc360-tab.selected-tab").removeClass("selected-tab");
      $(this).addClass("selected-tab");

      createChoicesSections(bottomTab.choices, orderedTabsData);
      $("#hmc360-options-container").scrollTop(0);
    });

    bottomTabsDiv.append(bottomTabDiv);

    if (bottomTab.neighbours.hasOwnProperty("top")) {
      for (const topTab of orderedTabsData.orderedTopElements) {
        if (topTab.elementKey == bottomTab.neighbours.top) {
          const topTabDiv = $("<div></div>").addClass("hmc360-tab").addClass(getTabSizeClass(topTab.choices[0].unit)).attr("id", topTab.elementKey);

          const topLabel = $(`<div>${topTab.cabinetLabel}</div>`);
          //topTabDiv.append(topLabel);
          const topImg = $(`<img src="${getUnitThumbnail(topTab.choices[0].unit)}"/>`);
          topTabDiv.append(topImg);

          topTabDiv.on("click", function () {
            $(".hmc360-tab.selected-tab").removeClass("selected-tab");
            $(this).addClass("selected-tab");

            createChoicesSections(topTab.choices, orderedTabsData);
            $("#hmc360-options-container").scrollTop(0);
          });
          topTabsDiv.append(topTabDiv);
        }
      }
    } else {
      const emptyTopTabDiv = $("<div></div>").addClass("hmc360-tab-empty").addClass(getTabSizeClass(bottomTab.choices[0].unit));
      const topImg = $(`<img src="${getUnitThumbnail("empty")}"/>`);
      emptyTopTabDiv.append(topImg);
      topTabsDiv.append(emptyTopTabDiv);
    }
  }
  tabsContainer.append(topTabsDiv);
  tabsContainer.append(bottomTabsDiv);
}

function getOrderedElements(selections) {
  //get all elements
  var allElements = [];
  for (const elementKey in selections.elements) {
    if (selections.elements.hasOwnProperty(elementKey)) {
      const element = selections.elements[elementKey];
      element.elementKey = elementKey;
      allElements.push(element);
    }
  }

  //seperate tops and bottoms
  var bottomElements = [];
  var topElements = [];
  allElements.forEach(el => {
    if (el.neighbours.hasOwnProperty("bottom")) topElements.push(el);
    else bottomElements.push(el);
  });

  //get first bottom element
  var orderedBottomElements = [];
  for (let i = 0; i < bottomElements.length; i++) {
    const bottomEl = bottomElements[i];
    if (!bottomEl.neighbours.hasOwnProperty("left")) {
      orderedBottomElements.push(bottomEl);
      break;
    }
  }

  //add the rest of the bottom elements in order
  addRightNeighbours(orderedBottomElements[0], bottomElements, orderedBottomElements);

  //get top elements in order
  var orderedTopElements = [];
  for (let i = 0; i < orderedBottomElements.length; i++) {
    bottomElement = orderedBottomElements[i];
    if (bottomElement.neighbours.hasOwnProperty("top")) {
      topElements.forEach(e => {
        if (e.elementKey == bottomElement.neighbours.top) orderedTopElements.push(e);
      });
    }
  }

  //wrap it up baby!
  return { orderedTopElements, orderedBottomElements };
}
function addRightNeighbours(element, elementArray, orderedArray) {
  if (element.neighbours.hasOwnProperty("right")) {
    elementArray.forEach(e => {
      if (e.elementKey == element.neighbours.right) {
        orderedArray.push(e);
        addRightNeighbours(e, elementArray, orderedArray);
      }
    });
  }
}
function attachChoicesToOrderedElements(orderedElements, choicesData) {
  const allOrderedElements = [...orderedElements.orderedTopElements, ...orderedElements.orderedBottomElements];

  const elementMap = new Map();

  for (const element of allOrderedElements) {
    element.choices = [];
    elementMap.set(element.elementKey, element);
  }

  for (const choice of choicesData) {
    const targetElement = elementMap.get(choice.unit_id);
    if (targetElement) {
      targetElement.choices.push(choice);
    }
  }

  return {
    orderedTopElements: orderedElements.orderedTopElements,
    orderedBottomElements: orderedElements.orderedBottomElements,
  };
}
function setElementCabinetLabels(oeo) {
  for (let i = 0; i < oeo.orderedBottomElements.length; i++) {
    cabinetLabel = createBottomElementLable(oeo.orderedBottomElements.length, i);
    oeo.orderedBottomElements[i].cabinetLabel = `Bottom ${cabinetLabel}`;

    if (oeo.orderedBottomElements[i].hasOwnProperty("neighbours") === false || oeo.orderedBottomElements[i].neighbours.hasOwnProperty("top") === false) {
      continue;
    }

    for (let ii = 0; ii < oeo.orderedTopElements.length; ii++) {
      if (oeo.orderedTopElements[ii].neighbours.bottom === oeo.orderedBottomElements[i].elementKey) {
        oeo.orderedTopElements[ii].cabinetLabel = `Top ${cabinetLabel}`;
        break;
      }
    }
  }
  return oeo;
}
function createBottomElementLable(length, i) {
  switch (length) {
    case 0:
      break;

    case 1:
      return `Cabinet`;

    case 2:
      return `${i === 0 ? "Left" : "Right"} Cabinet`;

    case 3:
      return `${i === 0 ? "Left" : i === 1 ? "Middle" : "Right"} Cabinet`;

    case 4:
      return `${i === 0 ? "Outer Left" : i === 1 ? "Inner Left" : i === 2 ? "Inner Right" : "Outer Right"} Cabinet`;

    case 5:
      return `${i === 0 ? "Outer Left" : i === 1 ? "Inner Left" : i === 2 ? "Middle" : i === 3 ? "Inner Right" : "Outer Right"} Cabinet`;

    default:
      return `Cabinet ${i + 1}`;
  }
}

function syncButtonStates() {
  //first enable all unit buttons
  $(".hmc360-unit-button").prop("disabled", false);

  //then disable buttons that match a disabledChoiceContainer
  $(".disabledChoiceContainer").each(function () {
    const slugValue = $(this).attr("id");
    $(`.hmc360-unit-button[slug-value="${slugValue}"]`).prop("disabled", true);
  });
}
function backToLineDrawing() {
  $("#hmc360-modular-tabs-container").html("");
  $("#hmc360-modular-tabs-container").hide();
  $("#hmc360-console-customizer-container").hide();
  $("#hmc360-special-buttons-container").hide();
  $("#hmc360-back-to-ouliner-button").hide();
  $("#hmc360-auto-scroll").hide();
  $("#hmc360-console-customizer-container").removeClass("revealed");
  $("#hmc360-modular-tabs-container").removeClass("revealed");
  $("#hmc360-select-individual").removeClass("set-as-selected");
  $("#hmc360-select-all").removeClass("set-as-selected");

  Begin(false);
  $("#variable-group_sections").trigger("click");
}
function isSelectAllChecked() {
  return $("#hmc360-select-all").hasClass("set-as-selected");
}

function scrollToSection(goingDown) {
  //goingDown is a boolean
  const container = $("#hmc360-options-container");
  const visibleSections = container
    .children()
    .filter(function () {
      return $(this).is(":visible");
    })
    .toArray();

  const scrollTop = container.scrollTop();

  if (goingDown) {
    for (let i = 0; i < visibleSections.length; i++) {
      if (visibleSections[i].offsetTop > scrollTop + 10) {
        container[0].scrollTo({
          top: visibleSections[i].offsetTop,
          behavior: "smooth",
        });
        break;
      }
    }
  } else {
    for (let i = visibleSections.length - 1; i >= 0; i--) {
      if (visibleSections[i].offsetTop < scrollTop - 10) {
        container[0].scrollTo({
          top: visibleSections[i].offsetTop,
          behavior: "smooth",
        });
        break;
      }
    }
  }
}
function setScrollOpacityEvents() {
  //this will set the scroll buttons' opacity as the user scrolls up and down

  const optionsContainer = $("#hmc360-options-container");

  const scrollUpButton = $("#hmc360-scroll-up-button");
  optionsContainer.on("scroll", () => {
    if (optionsContainer.scrollTop() <= 10) {
      scrollUpButton.css("opacity", "0");
    } else {
      scrollUpButton.css("opacity", "1");
    }
  });

  const scrollDownButton = $("#hmc360-scroll-down-button");
  optionsContainer.on("scroll", () => {
    const scrollTop = optionsContainer.scrollTop();
    const innerHeight = optionsContainer.innerHeight();
    const scrollHeight = optionsContainer[0].scrollHeight;
    const isAtBottom = scrollTop + innerHeight >= scrollHeight - 10;

    if (isAtBottom) {
      scrollDownButton.css("opacity", "0");
    } else {
      scrollDownButton.css("opacity", "1");
    }
  });
}

function setupSelectAllButton(orderedTabsData) {
  const allChoices = [];
  const seenChoices = new Set();

  //helper function to process each element
  function processElement(element) {
    if (element.choices && Array.isArray(element.choices)) {
      for (const choice of element.choices) {
        // Create a unique key based only on slugKey and slugValue
        const choiceKey = `${choice.slugKey}_${choice.slugValue}`;

        if (!seenChoices.has(choiceKey)) {
          seenChoices.add(choiceKey);
          allChoices.push(choice);
        }
      }
    }
  }

  //process top elements
  if (orderedTabsData.orderedTopElements && Array.isArray(orderedTabsData.orderedTopElements)) {
    orderedTabsData.orderedTopElements.forEach(processElement);
  }

  //process bottom elements
  if (orderedTabsData.orderedBottomElements && Array.isArray(orderedTabsData.orderedBottomElements)) {
    orderedTabsData.orderedBottomElements.forEach(processElement);
  }

  $("#hmc360-select-all").on("click", () => {
    $("#hmc360-select-all").addClass("set-as-selected");
    $("#hmc360-select-individual").removeClass("set-as-selected");

    $("#hmc360-modular-customizer-container").css("transform", "translateY(0%)");

    $("#hmc360-console-customizer-container").addClass("revealed");
    $("#hmc360-modular-tabs-container").addClass("revealed");

    $("#hmc360-auto-scroll").show();
    $(".hmc360-choice-button").hide();

    $(".hmc360-tab").addClass("hmc360-tab-highlight");
    createChoicesSections(allChoices, orderedTabsData);
    $("#hmc360-options-container").scrollTop(0);

    setTimeout(generateDetails, 500);
  });
}

function selectIndividualButton() {
  $(".hmc360-tab.selected-tab").removeClass("selected-tab");

  $("#hmc360-select-individual").addClass("set-as-selected");
  $("#hmc360-select-all").removeClass("set-as-selected");

  $("#hmc360-modular-customizer-container").css("transform", "translateY(0%)");

  $("#hmc360-console-customizer-container").addClass("revealed");
  $("#hmc360-modular-tabs-container").addClass("revealed");

  $("#hmc360-auto-scroll").show();
  $(".hmc360-choice-button").show();

  $(".hmc360-tab").removeClass("hmc360-tab-highlight");
  $(".hmc360-tab").first().trigger("click");

  setTimeout(generateDetails, 500);
}

function selectAllOrIndividualMenuButton(selectAllClicked) {
  $("#hmc360-modular-customizer-container").show();
  $("#hmc360-console-customizer-container").show();
  $("#hmc360-back-to-ouliner-button").show();
  $("#hmc360-modular-tabs-container").css("display", "flex");
  $("#hmc360-options-container").css("display", "flex");
  $("#hmc360-special-buttons-container").css("display", "flex");

  $("#hmc360-configure-all-menu").hide();

  if (selectAllClicked) {
    $("#hmc360-select-all").addClass("set-as-selected");
  } else {
    $("#hmc360-select-individual").addClass("set-as-selected");
  }

  //loadCustomizationOptions();
}

//This is where the next and previous buttons are generated
function getEndOfChoicesDiv(choicesData, orderedTabsData) {
  const sectionDiv = $("<div></div>").addClass("hmc360-section");
  const choiceButtonsContainer = $("<div></div>").addClass("hmc360-choice-buttons-container");

  const prevButton = $("<button></button>").addClass("hmc360-choice-button").addClass("hmc360-next-prev-button");
  const prevLabel = $("<div></div>").text("Previous Unit");
  prevButton.append(
    `<img src="https://cdn.shopify.com/s/files/1/0364/2136/9900/files/UpArrow.png?v=1750277700" class="prev-button-img" width="auto" height="auto"/>`
  );
  prevButton.append(prevLabel);

  const nextButton = $("<button></button>").addClass("hmc360-choice-button").addClass("hmc360-next-prev-button");
  const nextLabel = $("<div></div>").text("Next Unit");
  nextButton.append(nextLabel);
  nextButton.append(
    `<img src="https://cdn.shopify.com/s/files/1/0364/2136/9900/files/UpArrow.png?v=1750277700" class="next-button-img" width="auto" height="auto"/>`
  );

  const pdfButton = $("<button></button>").attr("id", "hmc360-modular-pdf-button").addClass("hmc360-next-prev-button").addClass("hmc360-choice-button");
  const pdfLabel = $("<div></div>").text("Save as PDF");
  pdfButton.append(pdfLabel);

  const pdfLoadingGif = $(`<img id='modular-pdf-loading' src='https://cdn.shopify.com/s/files/1/0364/2136/9900/files/hm-ai-loading.gif?v=1749750020'/>`);

  const addToCartButtonContainer = $("<div id='hmc360-modular-add-to-cart-button-container'></div>");

  const addToCartButton = $("<button></button>")
    .attr("id", "#hmc360-modular-add-to-cart-button")
    .addClass("hmc360-next-prev-button")
    .addClass("hmc360-choice-button");
  const addToCartLabel = $("<div></div>").text("Add to Cart");
  addToCartButton.append(addToCartLabel);
  addToCartButtonContainer.append(addToCartButton);

  const modularInfoMessage = $("<div></div>")
    .attr("id", "hmc360-modular-info-message")
    .text("Modular cabinets are built from multiple components (SKUs). All selected SKUs will be added to your cart to reflect the total cost accurately.");

  addToCartButtonContainer.append(modularInfoMessage);

  let prevElementKey = getPreviousElementKey(choicesData[0].unit_id, [...orderedTabsData.orderedTopElements, ...orderedTabsData.orderedBottomElements]);
  if (prevElementKey != null && !isSelectAllChecked()) {
    prevButton.on("click", async () => {
      $(`#${prevElementKey}`).trigger("click");
    });
    choiceButtonsContainer.append(prevButton);
  }

  pdfButton.on("click", saveModularPDF);
  choiceButtonsContainer.append(pdfButton);
  choiceButtonsContainer.append(pdfLoadingGif);

  addToCartButton.on("click", addModularToCart);

  choiceButtonsContainer.append(addToCartButtonContainer);
  
  let nextElementKey = getNextElementKey(choicesData[0].unit_id, [...orderedTabsData.orderedTopElements, ...orderedTabsData.orderedBottomElements]);
  if (nextElementKey != null && !isSelectAllChecked()) {
    nextButton.on("click", async () => {
      $(`#${nextElementKey}`).trigger("click");
    });
    choiceButtonsContainer.append(nextButton);
  }

  sectionDiv.append(choiceButtonsContainer);
  sectionDiv.append($("<div></div>").attr("id", "hmc360-modular-sku-list"));

  return sectionDiv;
}

function getPreviousElementKey(unit_id, orderedTabsData) {
  const currentIndex = orderedTabsData.findIndex(element => element.elementKey === unit_id);

  if (currentIndex <= 0) return null;

  return orderedTabsData[currentIndex - 1].elementKey;
}

function getNextElementKey(unit_id, orderedTabsData) {
  const currentIndex = orderedTabsData.findIndex(element => element.elementKey === unit_id);

  if (currentIndex === -1 || currentIndex === orderedTabsData.length - 1) {
    return null;
  }

  return orderedTabsData[currentIndex + 1].elementKey;
}

function showFinishBuilingButtonAppropriately() {
  console.log("rand");
  const finishBtn = $("#finishButton");
  if (!finishBtn.prop("disabled") || !finishBtn.hasClass("hidden")) {
    $("#hmc360-finish-building-button").show();
  } else {
    $("#hmc360-finish-building-button").hide();
  }
}

function setupDragging() {
  let draggedElem = null;

  // Use event delegation for dragstart (supports dynamic elements)
  $(document).on("dragstart", ".draggable", function (e) {
    draggedElem = this;
  });

  // Existing droppable code (if droppables are static, this is fine)
  $(".droppable").on("dragover", function (e) {
    e.preventDefault();
  });

  $(".droppable").on("drop", function (e) {
    e.preventDefault();
    if (draggedElem) {
      $(draggedElem).trigger("click");
      draggedElem = null;
    }
  });
}

function setupFinishBuildingButtonObserver() {
  const finishBtn = $("#finishButton")[0];
  if (!finishBtn) return;

  const finishBtnObserver = new MutationObserver(showFinishBuilingButtonAppropriately);
  finishBtnObserver.observe(finishBtn, {
    attributes: true,
    attributeFilter: ["class", "disabled"],
  });
}

function isAutoScroll() {
  return $("#hmc360-auto-scroll").hasClass("set-as-selected");
}
function setAutoScroll() {
  if (isAutoScroll()) {
    $("#hmc360-auto-scroll").removeClass("set-as-selected");
  } else {
    $("#hmc360-auto-scroll").addClass("set-as-selected");
  }
}

function getTabSizeClass(unit) {
  const unitThumbnailMap = {
    "MC28A Base": "small-tab",
    "MC28B Base": "small-tab",
    "MC28C Base": "small-tab",
    "MC28D Base": "small-tab",
    "MC28E Base": "small-tab",
    "MC28F Base": "small-tab",
    "MC43A Base": "medium-tab",
    "MC71A Base": "large-tab",
    "MC71B Base": "large-tab",
    "MC71C Base": "large-tab",
    "MH28A Top": "small-tab",
    "MH28B Top": "small-tab",
    "MH43A Top": "medium-tab",
    "MH71A Top": "large-tab",
  };
  return unitThumbnailMap[unit] || null;
}

function getUnitThumbnail(unit) {
  const unitThumbnailMap = {
    "MC28A Base": "https://cdn.intiaro.com/media/gen/RAW/q/m/t/feyhok-60hvc9d5rboa.png",
    "MC28B Base": "https://cdn.intiaro.com/media/gen/RAW/r/c/g/syngu-cfs7eqlo9th3w.png",
    "MC28C Base": "https://cdn.intiaro.com/media/gen/RAW/l/r/h/dymbalcklno1qqas1qw.png",
    "MC28D Base": "https://cdn.intiaro.com/media/gen/RAW/q/w/b/xex7iuoqhqxsz_xpo9q.png",
    "MC28E Base": "https://cdn.intiaro.com/media/gen/RAW/r/u/a/qu5izg4h_mkgjpyjhda.png",
    "MC28F Base": "https://cdn.intiaro.com/media/gen/RAW/u/v/_/u2s0xvhqkej2bffupsq.png",
    "MC43A Base": "https://cdn.intiaro.com/media/gen/RAW/m/y/c/aspjywhqrxrts6u-dhw.png",
    "MC71A Base": "https://cdn.intiaro.com/media/gen/RAW/c/q/h/xsiw4xhslu1mgwdqsbw.png",
    "MC71B Base": "https://cdn.intiaro.com/media/gen/RAW/d/u/g/9pe3w8cxuh6ief1f7uw.png",
    "MC71C Base": "https://cdn.intiaro.com/media/gen/RAW/5/1/i/4jt5eozs0y10qtdf2kg.png",
    "MH28A Top": "https://cdn.intiaro.com/media/gen/RAW/4/_/t/qlopsqjfumztlwovtjw.png",
    "MH28B Top": "https://cdn.intiaro.com/media/gen/RAW/h/z/v/rkrko1jyssximtayrsw.png",
    "MH43A Top": "https://cdn.intiaro.com/media/gen/RAW/f/x/7/yxghdpr0gar5herxbka.png",
    "MH71A Top": "https://cdn.intiaro.com/media/gen/RAW/r/4/x/b9b_7bvyblkggjqs7la.png",
    empty: "https://cdn.shopify.com/s/files/1/0364/2136/9900/files/empty_unit.jpg?v=1751051640",
  };
  return unitThumbnailMap[unit] || null;
}

function getChoiceThumbnail(choice) {
  const choiceThumbnailMap = {
    "PLAIN GLASS DOOR": "https://cdn.shopify.com/s/files/1/0364/2136/9900/files/Door_1_PlainGlass_Square.jpg?v=1750250545",
    "GLASS PANEL DOOR": "https://cdn.shopify.com/s/files/1/0364/2136/9900/files/Door_3_GlassPane_Square.jpg?v=1750250545",
    "INSET PANEL DOOR WITH MOULDING": "https://cdn.shopify.com/s/files/1/0364/2136/9900/files/Door_4_BeveledPanel_Square.jpg?v=1750250545",
    "INSET PANEL DOOR": "https://cdn.shopify.com/s/files/1/0364/2136/9900/files/Door_5_InsetPanel_Square.jpg?v=1750250545",
    "INSET PANEL DRAWER": "https://cdn.shopify.com/s/files/1/0364/2136/9900/files/MC_Drawer_9.png?v=1752074349",
    "INSET PANEL DRAWER WITH MOULDING DETAIL": "https://cdn.shopify.com/s/files/1/0364/2136/9900/files/MC_Drawer_8.png?v=1752074349",
    "NICKEL KNOB": "https://cdn.shopify.com/s/files/1/0364/2136/9900/files/knob_gs.jpg?v=1750250544",
    "NICKEL BAR PULL": "https://cdn.shopify.com/s/files/1/0364/2136/9900/files/barpull_nickel.jpg?v=1750250543",
    "NICKEL BAR": "https://cdn.shopify.com/s/files/1/0364/2136/9900/files/barpull_nickel.jpg?v=1750250543",
    "NICKEL ELEGANT PULL": "https://cdn.shopify.com/s/files/1/0364/2136/9900/files/elegant-nickel-handle.jpg?v=1750682815",
    "BRASS KNOB": "https://cdn.shopify.com/s/files/1/0364/2136/9900/files/knob_brass.jpg?v=1750250544",
    "BRASS BAR PULL": "https://cdn.shopify.com/s/files/1/0364/2136/9900/files/barpull_brass.jpg?v=1750250543",
    "BRASS BAR": "https://cdn.shopify.com/s/files/1/0364/2136/9900/files/barpull_brass.jpg?v=1750250543",
    "BRASS ELEGANT PULL": "https://cdn.shopify.com/s/files/1/0364/2136/9900/files/elegant-brass-handle.jpg?v=1750682815",
    "IRON KNOB": "https://cdn.shopify.com/s/files/1/0364/2136/9900/files/knob_iron.jpg?v=1750250544",
    "IRON BAR PULL": "https://cdn.shopify.com/s/files/1/0364/2136/9900/files/barpull_iron.jpg?v=1750250543",
    "IRON BAR": "https://cdn.shopify.com/s/files/1/0364/2136/9900/files/barpull_iron.jpg?v=1750250543",
    "IRON ELEGANT PULL": "https://cdn.shopify.com/s/files/1/0364/2136/9900/files/elegant-iron-handle.jpg?v=1750682815",
  };
  return choiceThumbnailMap[choice] || null;
  console;
}

function getVariantIdByUnit(unit) {
  const unitVariantId = {
    MC28A: 41215123980332,
    MC28B: 41215124013100,
    MC28C: 44021089271852,
    MC28D: 41215124209708,
    MC28E: 41215124242476,
    MC28F: 44021089271852,
    MC43A: 41215124439084,
    MC71A: 41188116103212,
    MC71B: 41215124570156,
    MC71C: 44021089271852,
    MH28A: 41215124668460,
    MH28B: 41215124733996,
    MH43A: 41050315554860,
    MH71A: 41188116004908,
  };
  return unitVariantId[unit] || null;
}

function getCurrentDate() {
  const currentDate = new Date();

  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  const hours = String(currentDate.getHours()).padStart(2, "0");
  const minutes = String(currentDate.getMinutes()).padStart(2, "0");
  const seconds = String(currentDate.getSeconds()).padStart(2, "0");

  const formattedDate = `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;

  return formattedDate;
}
